Object.defineProperty(exports,"__esModule",{value:true});var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _property2=require("lodash/property");var _property3=_interopRequireDefault(_property2);var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);
var _collection=require("./collection");var _collection2=_interopRequireDefault(_collection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

{
getPadding:function getPadding(props){
var padding=typeof props.padding==="number"?props.padding:0;
var paddingObj=typeof props.padding==="object"?props.padding:{};
return{
top:paddingObj.top||padding,
bottom:paddingObj.bottom||padding,
left:paddingObj.left||padding,
right:paddingObj.right||padding};

},

getStyles:function getStyles(style,defaultStyles,height,width){
if(!style){
return(0,_defaults3.default)({parent:{height:height,width:width}},defaultStyles);
}var

data=style.data,labels=style.labels,parent=style.parent;
var defaultParent=defaultStyles&&defaultStyles.parent||{};
var defaultLabels=defaultStyles&&defaultStyles.labels||{};
var defaultData=defaultStyles&&defaultStyles.data||{};
return{
parent:(0,_defaults3.default)({height:height,width:width},parent,defaultParent),
labels:(0,_defaults3.default)({},labels,defaultLabels),
data:(0,_defaults3.default)({},data,defaultData)};

},

evaluateProp:function evaluateProp(prop,data,active){
return(0,_isFunction3.default)(prop)?prop(data,active):prop;
},

evaluateStyle:function evaluateStyle(style,data,active){var _this=this;
if(!style||!Object.keys(style).some(function(value){return(0,_isFunction3.default)(style[value]);})){
return style;
}
return Object.keys(style).reduce(function(prev,curr){
prev[curr]=_this.evaluateProp(style[curr],data,active);
return prev;
},{});
},

getRange:function getRange(props,axis){

var isVertical=axis!=="x";
var padding=this.getPadding(props);
if(isVertical){
return[props.height-padding.bottom,padding.top];
}
return[padding.left,props.width-padding.right];
},

createAccessor:function createAccessor(key){


if((0,_isFunction3.default)(key)){
return key;
}else if(key===null||typeof key==="undefined"){

return function(x){return x;};
}

return(0,_property3.default)(key);
},

modifyProps:function modifyProps(props,fallbackProps,role){
var theme=props.theme&&props.theme[role]?props.theme[role]:{};
var themeProps=(0,_omit3.default)(theme,["style"]);
var baseProps=(0,_defaults3.default)({},props,themeProps,fallbackProps);
return(0,_defaults3.default)({},baseProps,{clipWidth:baseProps.width,clipHeight:baseProps.height});
},









getCurrentAxis:function getCurrentAxis(axis,horizontal){
var otherAxis=axis==="x"?"y":"x";
return horizontal?otherAxis:axis;
},





isVertical:function isVertical(props){
var orientation=props.orientation||(props.dependentAxis?"left":"bottom");
var vertical={top:false,bottom:false,left:true,right:true};
return vertical[orientation];
},





stringTicks:function stringTicks(props){
return props.tickValues!==undefined&&_collection2.default.containsStrings(props.tickValues);
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/helpers.js
// module id = 30
// module chunks = 0 1